export enum PricingEnum {
    PROMOTION = 'promotion',
    BEST= 'best',
    AUCTION= 'auction',
    FIXED= 'fixed'
}
